import { getApiExportBaseUrl, getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function findInfoSet(infoSetId) {
    return await Vue.axios.get(`${getApiUrl('v4')}/info_sets/${infoSetId}`);
}
export async function getExportEvents(page = 1) {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/export/events?page=${page}`);
}
export async function getExportEventProgress(eventId) {
    return await Vue.axios.get(`${getApiExportBaseUrl()}/export/events/${eventId}/progress?skip_handle_error`);
}
export async function cancelExportation(eventId) {
    return await Vue.axios.post(`${getApiExportBaseUrl()}/export/${eventId}/cancelExport`);
}
export async function listInfoSetsAllowedToExport({ page, query }) {
    return await Vue.axios.get(`${getApiUrl('v4')}/info_sets/allowed_to_export?page=${page}&query=${query}`);
}
export async function llmListDecisors(params) {
    return await Vue.axios.get(`${getApiUrl('v4')}/info_sets/llm_decisors`, {
        params,
    });
}
export async function llmListCompanies(params) {
    return await Vue.axios.get(`${getApiUrl('v4')}/info_sets/llm_companies`, {
        params,
    });
}
